import React, { ImgHTMLAttributes } from 'react';
import './logo.scss';

const Logo = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img
    alt='Backroom logo'
    className='logo'
    {...props}
    src='/images/Lockup_masthead_transp_550x128.png'
  />
);

export default Logo;
